import React, { useState } from "react";
import Navbar from "../navbar/Navbar";
import HLVOutput from "./HLVOutput";
import HLVForm from "./HLVForm";

const HumanLifeValue = () => {
  const [userInfo, setUserInfo] = useState({ editing: true });

  const sampleUserData = {
    editing: false,
    fullName: "Rishav Anand",
    mobileNumber: "8407045622",
    email: "rishva343@gmail.com",
    dob: "2002-11-03",
    children: "yes",
    childAge: "11",
    married: "yes",
    retirementAge: "45",
    monthlyIncome: "50000",
    monthlyExpenses: "20000",
    monthlyLiabilities: "5000",
    address: "Rose Capital City, Mumbai ,32212",
    pincode: "110001",
    lifeCoverSumAssured: "50000",
    lifeCoverTotalPremiumPaid: "10000",
    healthCoverSumInsured: "500000",
    healthCoverTotalPremiumPaid: "10000",
    smoking: "yes",
    smokingDetails: "Regularly",
    drinking: "yes",
    drinkingDetails: "Occassionaly",
    twoWheeler: "yes",
    fourWheeler: "yes",
    monthlySavings: 25000,
  };

  return (
    <div>
      <Navbar />
      <main className="Body pt-20">
        {/* Open form if user is editing details else show output */}
        {userInfo?.editing ? (
          <HLVForm setUserInfo={setUserInfo} userInfo={userInfo} />
        ) : (
          <div>
            <div className="w-full">
              <button
                className="bg-pink-700 text-md p-2 rounded shadow-sm font-serif font-semibold hover:bg-pink-500 text-white"
                onClick={() =>
                  setUserInfo((prev) => ({ ...prev, editing: true }))
                }
              >
                &lt; Re-enter Details
              </button>
            </div>
            <HLVOutput user={userInfo} />
          </div>
        )}
      </main>
    </div>
  );
};

export default HumanLifeValue;
